function SortSicCodeCategories(_isOmit)
{
    var sortByDescription = $("input:radio[class=SicCodeCategoryListSort]:checked").val();

	$(".SelectionContent[contenttoload*='SicCodeCategoryList']").html('<img alt="Refreshing..." src="/Images/Common/LoadingGreenMed.gif" class="AccordionPaneLoadingImage">');
	
    $.DotComAjax({
        url: "/CanadianBusiness/SicCodeCategoryListAjax?isOmit=" + _isOmit + "&sortByDescription=" + sortByDescription,
        cache: false,
//        async: true,
        success: function (data) {
			$(".SelectionContent[contenttoload*='SicCodeCategoryList']").html(data);
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
			$(".SelectionContent[contenttoload*='SicCodeCategoryList']").html('<div style="padding-left: 30px;"><font color="red">There was an error retrieving the SIC Codes list</font></div>');
        },
        async: true
    });
}

function InitializeSicCodeCategories() {

    $('.lvl1-sic-code input:checkbox', '#SicCodeCategoryList').click(function (e) {
        var currentItem = $(this).closest('.sic-code-parent');
        if ($(this).is(':checked')) {
            currentItem.find('input:checkbox').prop('checked', true);
        } else {
            currentItem.find('input:checkbox').prop('checked', false);
        }

        UpdateSelectedSicCodeItems($(this).attr('id'), null, null);
    });

    $('.lvl2-sic-code input:checkbox', '#SicCodeCategoryList').click(function () {

        $(this).closest('.sic-code-child').find('input:checkbox').prop('checked', $(this).is(':checked'));

        var currentItem = $(this).closest('.sic-code-parent');
        var secondLevel = currentItem.find('.lvl2-sic-code');
        var secondLevelChk = secondLevel.find('input:checkbox');
        var secondLevelChkSelected = secondLevel.find('input:checkbox:checked');

        if (secondLevelChk.length === secondLevelChkSelected.length) {
            currentItem.find('.lvl1-sic-code input:checkbox').prop('checked', true);
        } else {
            currentItem.find('.lvl1-sic-code input:checkbox').prop('checked', false);
        }
        var firstLevelId = currentItem.find('.lvl1-sic-code input:checkbox').attr('id');
        UpdateSelectedSicCodeItems(firstLevelId, $(this).is(':checked') ? $(this).attr('id') : null);
    });

    $('.lvl3-sic-code input:checkbox', '#SicCodeCategoryList').click(function () {

        $(this).closest('.sic-code-grand-child').find('input:checkbox').prop('checked', $(this).is(':checked'));

        var currentItem = $(this).closest('.sic-code-parent');
        var thirdLevel = $(this).closest('.lvl3-sic-code-tree');
        var thirdLevelChk = thirdLevel.find('input:checkbox');
        var thirdLevelChkSelected = thirdLevel.find('input:checkbox:checked');

        var secondLevelSingleChk = $(this).closest('.sic-code-child').find('.lvl2-sic-code input:checkbox')
        if (thirdLevelChk.length === thirdLevelChkSelected.length) {
            secondLevelSingleChk.prop('checked', true);
        } else {
            secondLevelSingleChk.prop('checked', false);
        }

        var secondLevel = currentItem.find('.lvl2-sic-code');
        var secondLevelChk = secondLevel.find('input:checkbox');
        var secondLevelChkSelected = secondLevel.find('input:checkbox:checked');

        if (secondLevelChk.length === secondLevelChkSelected.length) {
            currentItem.find('.lvl1-sic-code input:checkbox').prop('checked', true);
        } else {
            currentItem.find('.lvl1-sic-code input:checkbox').prop('checked', false);
        }
        var firstLevelId = currentItem.find('.lvl1-sic-code input:checkbox').attr('id');
        UpdateSelectedSicCodeItems(firstLevelId, secondLevelSingleChk.is(':checked') ? secondLevelSingleChk.attr('id') : null);
    });

    $('.lvl4-sic-code input:checkbox', '#SicCodeCategoryList').click(function () {
        var currentItem = $(this).closest('.sic-code-parent');

        var fourthLevel = $(this).closest('.lvl4-sic-code-tree');
        var fourthLevelChk = fourthLevel.find('input:checkbox');
        var fourthLevelChkSelected = fourthLevel.find('input:checkbox:checked');

        if (fourthLevelChk.length === fourthLevelChkSelected.length) {
            $(this).closest('.sic-code-grand-child').find('.lvl3-sic-code input:checkbox').prop('checked', true);
        } else {
            $(this).closest('.sic-code-grand-child').find('.lvl3-sic-code input:checkbox').prop('checked', false);
        }

        var thirdLevel = $(this).closest('.lvl3-sic-code-tree');
        var thirdLevelChk = thirdLevel.find('input:checkbox');
        var thirdLevelChkSelected = thirdLevel.find('input:checkbox:checked');

        var secondLevelSingleChk = $(this).closest('.sic-code-child').find('.lvl2-sic-code input:checkbox');
        if (thirdLevelChk.length === thirdLevelChkSelected.length) {
            secondLevelSingleChk.prop('checked', true);
        } else {
            secondLevelSingleChk.prop('checked', false);
        }

        var secondLevel = currentItem.find('.lvl2-sic-code');
        var secondLevelChk = secondLevel.find('input:checkbox');
        var secondLevelChkSelected = secondLevel.find('input:checkbox:checked');

        if (secondLevelChk.length === secondLevelChkSelected.length) {
            currentItem.find('.lvl1-sic-code input:checkbox').prop('checked', true);
        } else {
            currentItem.find('.lvl1-sic-code input:checkbox').prop('checked', false);
        }
        var firstLevelId = currentItem.find('.lvl1-sic-code input:checkbox').attr('id');
        UpdateSelectedSicCodeItems(firstLevelId, secondLevelSingleChk.is(':checked') ? secondLevelSingleChk.attr('id') : null);
    });

    UpdateSelectedSicCodeItems(null, null);
}

function FilterSicCodeSelections(_id, _filterPrefix) {
    var newSelections = '';
    var selections = $(_id).val().split('~');

    for (i = 0; i < selections.length; i++) {
        if (!(selections[i].lastIndexOf(_filterPrefix, 0) === 0) && selections[i].length > 0)
            newSelections = newSelections + '~' + selections[i];
    }

    $(_id).val(newSelections);
}

function UpdateSelectedSicCodeItems(_firstLevelId, _secondLevelId) {
    var selector1 = null;
    if (_firstLevelId == null)
        selector1 = $('.sic-code-parent', '#SicCodeCategoryList');
    else
        selector1 = $('.sic-' + _firstLevelId, '#SicCodeCategoryList');
    $(selector1).each(function (index, item) {
        var firstLevelChk = $(item).find('.lvl1-sic-code input:checkbox');
        var selectionId = '#SelectedSicCodeCategoryItems' + firstLevelChk.attr('id');

        var firstLevelChkSelected = $(item).find('.lvl1-sic-code input:checkbox:checked');
        if (firstLevelChkSelected.length > 0) {
            var firstLevelId = firstLevelChk.attr('id');
            var firstLevelSelection = "~" + firstLevelId + ":" + $("#DescriptionS" + firstLevelId).html();
            $(selectionId).val(firstLevelSelection);
        }
        else {
            var selector2 = null;
            if (_secondLevelId == null) {
                selector2 = item;
                $(selectionId).val("");
            }
            else {
                selector2 = $('.sic-' + _secondLevelId, '#SicCodeCategoryList');
                FilterSicCodeSelections(selectionId, _secondLevelId);
            }
            $(selector2).find('.lvl2-sic-code input:checkbox').each(function (i, child) {
                if ($(child).is(':checked')) {
                    var secondLevelId = $(child).attr('id');
                    var secondLevelSelection = "~" + secondLevelId + ":" + $("#DescriptionS" + secondLevelId).html();
                    $(selectionId).val($(selectionId).val() + secondLevelSelection);
                } else {
                    $(child).closest('.sic-code-child').find('.lvl3-sic-code input:checkbox').each(function (j, grandchild) {
                        var thirdLevelId = $(grandchild).attr('id');
                        if ($(grandchild).is(':checked')) {
                            var thirdLevelSelection = "~" + thirdLevelId + ":" + $("#DescriptionS" + thirdLevelId).html();
                            $(selectionId).val($(selectionId).val() + thirdLevelSelection);
                        } else {
                            var greatGrandChildCount = $('#SicCodeChildrenInitialCount' + thirdLevelId).val().split('~');
                            if ((_firstLevelId == null && parseInt(greatGrandChildCount[0]) > 0) || _firstLevelId != null) {
                                $(grandchild).closest('.sic-code-grand-child').find('.lvl4-sic-code input:checkbox:checked').each(function (k, greatGrandChild) {
                                    var fourthLevelId = $(greatGrandChild).attr('id');
                                    var fourthLevelSelection = "~" + fourthLevelId + ":" + $("#DescriptionS" + fourthLevelId).html();
                                    $(selectionId).val($(selectionId).val() + fourthLevelSelection);
                                });
                            }
                        }
                    });
                }
            });
        }
    });

    $('#SelectedSicCodeCategoryItems').val("");
    $('.sic-category-selection', '#SicCodeCategoryList').each(function (index, item) {
        $('#SelectedSicCodeCategoryItems').val($('#SelectedSicCodeCategoryItems').val() + $(item).val());
    });
}

function HideShowSicCodeChildren(evt) {
    var key = evt.id;
    key = key.replace("imgS", "");

    if ($('#HeaderS' + key + ' input:checkbox:first').is(":checked")) {
        $('#SicCodeChildren' + key + ' input:checkbox').prop('checked', $('#HeaderS' + key + " input:checkbox").prop('checked'));
    }

    if ($('#imgS' + key).attr('src') == '/Images/Common/plus_new.gif') {
        $('#imgS' + key).attr('src', '/Images/Common/minus_new.gif');
        $('#SicCodeChildren' + key).show();

    }
    else {
        $('#imgS' + key).attr('src', '/Images/Common/plus_new.gif');
        $('#SicCodeChildren' + key).hide();
    }
}
